import { render, staticRenderFns } from "./CustomerShoppingList.vue?vue&type=template&id=394727c5&scoped=true&"
import script from "./CustomerShoppingList.vue?vue&type=script&lang=js&"
export * from "./CustomerShoppingList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerShoppingList.vue?vue&type=style&index=0&id=394727c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394727c5",
  null
  
)

export default component.exports